export default class SetUpUserSessionStateError extends Error {

}
